export default __webpack_public_path__ + "static/media/SunIcon.2f585406.svg";